import { z } from 'zod';

/**
 * Schema do formulário de upsert de Provider. Mensagens são **chaves i18n**
 * (regra §5.3): resolvidas em JSX via `useFieldError`. No modo "editar",
 * `apiKey` vem vazio para preservar a chave atual — validação fica opcional.
 */
export function buildProviderFormSchema(opts: { requireApiKey: boolean }) {
  const apiKeyBase = z.string().trim();
  return z.object({
    displayName: z.string().trim().min(1, 'ai-admin:providerForm.validation.displayNameRequired'),
    modelId: z.string().trim().min(1, 'ai-admin:providerForm.validation.modelIdRequired'),
    baseUrl: z
      .string()
      .trim()
      .min(1, 'ai-admin:providerForm.validation.baseUrlRequired')
      .url('ai-admin:providerForm.validation.baseUrlInvalid'),
    apiKey: opts.requireApiKey
      ? apiKeyBase.min(8, 'ai-admin:providerForm.validation.apiKeyTooShort')
      : apiKeyBase.refine((v) => v.length === 0 || v.length >= 8, {
          message: 'ai-admin:providerForm.validation.apiKeyTooShort',
        }),
  });
}

export type ProviderFormInput = z.infer<ReturnType<typeof buildProviderFormSchema>>;
